import React from "react";
import { connect } from "react-redux";
import Alert from "../components/Alert";
import { Formik, Form } from "formik";
import * as yup from "yup";
import PropTypes from "prop-types";

import LabeledFormField from "../components/LabeledFormField";
import Button from "../components/Button";
import { axiosClient } from "../redux_axios_middleware";
import { fetchUser } from "../actions/user";

import { PageContainer } from "../styles/common";

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  fetchUser: () => dispatch(fetchUser()),
});

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("Enter a valid email address.")
    .required("Email address is required."),
});

const ChangeEmail = (props) => {
  const { user, fetchUser, history } = props;

  const onSubmit = async (values, actions) => {
    actions.setStatus(null);

    try {
      await axiosClient({
        method: "PUT",
        url: "user.json",
        data: { email: values.email },
      });
    } catch {
      actions.setStatus("Could not update email");
      return;
    }

    await fetchUser();
    history.push("/settings");
  };

  return (
    <PageContainer>
      <div className="max-w-7xl w-full px-4 sm:px-6 lg:px-8 mt-3">
        <div className="max-w-xl mx-auto">
          <h1 className="text-2xl mb-3">Change Email</h1>
          <Formik
            initialValues={{
              email: user.email,
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validate={(values) => {
              const errors = {};

              if (values.email === user.email) {
                errors.email = "You already use this email";
              }

              return errors;
            }}
          >
            {({ status, isValid, isSubmitting }) => (
              <Form>
                <LabeledFormField
                  label="Email Address"
                  type="email"
                  name="email"
                  tabIndex="1"
                />
                {status && <Alert color="danger">{status}</Alert>}
                <Button
                  intent="link"
                  className="mt-2"
                  type="submit"
                  disabled={!isValid || isSubmitting}
                >
                  Change Email
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </PageContainer>
  );
};

ChangeEmail.propTypes = {
  user: PropTypes.object.isRequired,
  fetchUser: PropTypes.func.isRequired,
  history: PropTypes.any.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeEmail);
